import { retrieveMatterSettingStaticsV2 } from "@/lib/data/requests/matters/matter-setting-statics";
import { queryKeys } from "@/lib/data/static/query-keys";

export const retrieveMatterSettingStaticsQueryOptions = () => ({
  queryKey: [queryKeys.matterSettingStatics],
  queryFn: retrieveMatterSettingStaticsV2,
});
